import type { TextProps } from '@ksyos/design-system';
import { Form, Text } from '@ksyos/design-system';
import { styled } from 'styled-components';

export const StyledContainer = styled.div`
    ${({ theme }) => theme.mediaQueries.small} {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        width: 100%;
        flex-direction: column;
    }
`;

export const StyledForm = styled(Form)`
    width: 100%;
    padding: 56px 16px;
    background-color: var(--kds-color-background-default);
    border-radius: var(--kds-border-radius-base);
    box-shadow: var(--kds-box-shadow-base);

    ${({ theme }) => theme.mediaQueries.small} {
        width: 544px;
        padding: 56px;
    }
`;

export const StyledLogo = styled.div<{ height?: string; width?: string }>`
    width: ${(props) => (props.width ? 'auto' : '300px')};
    height: ${(props) => (props.height ? 'auto' : '37px')};
    margin: 0 auto 16px;

    img {
        max-height: 100%;
        height: ${(props) => props.height ?? 'auto'};
        width: ${(props) => props.width ?? 'auto'};
        display: block;
        margin: auto;
    }
`;

export const StyledSelectEmploymentOption = styled.a`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 18px;
    transition: all 0.2s ease-out;
    position: relative;
    border-radius: 2px;
    cursor: pointer;
    box-shadow: inset 0 0 0 1px #dbd5d0;
    width: 100%;
    height: 120px;
    text-decoration: none;

    &:focus,
    &:hover {
        outline: 0;
        box-shadow: inset 0 0 0 1px #50463f;
    }
`;

export const StyledSelectEmploymentOptionText = styled(Text)`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export function LoginTitle({
    as = 'h1',
    size = '2xl',
    fontWeight = 'bold',
    color = 'subtle',
    letterSpacing = 'tight',
    children,
    ...props
}: TextProps) {
    return (
        <Text
            as={as}
            color={color}
            fontWeight={fontWeight}
            letterSpacing={letterSpacing}
            size={size}
            {...props}
        >
            {children}
        </Text>
    );
}
